import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
// import { exportToPPT_tableCss } from '../../../../util'

export const OuterWrapper = styled(Box)(`
    width:100%;
    padding:0;
    
    &.exportToPPT {
        width: 1200px;
        height: 535px;
        .snapshotRow {
            width: 1300px;
            height: 500px;
        }
        .snapshotRow .grid-item{
            padding: 4 !important;
        }
    }
`)

export const InnerWrapper = styled(Box)(`
    display:flex; flex-direction: column; width:100%; position: relative;
    padding-bottom: 20px !important;

`)
